module.exports = __webpack_public_path__ + "img/feature-playlists.2c7aa5d4.png";